import React from "react";
import { Route, Routes } from "react-router-dom";

import NotFound from "../../pages/NotFound";
import AssistantHome from "./pages/AssistantHome";

type Props = {
  onRouteNotFound?: () => void;
};

export default class Assistant extends React.Component<Props> {
  render() {
    const { onRouteNotFound } = this.props;
    return (
      <Routes>
        <Route path="/" element={<AssistantHome />} />
        <Route path="" element={<AssistantHome />} />
        <Route
          path="*"
          element={onRouteNotFound ? <>{onRouteNotFound()}</> : <NotFound />}
        />
      </Routes>
    );
  }
}
